import chatStartClick from './chatStartClick';
import contactUsLinkClick from './contactUsLinkClick';
import registerHubspotFormStart from './registerHubspotFormStart';
import registerHubspotFormSubmit from './registerHubspotFormSubmit';

export const eventListeners = {
  chatStartClick,
  contactUsLinkClick,
  registerHubspotFormStart,
  registerHubspotFormSubmit,
};

export const initialize = () => {
  window.dataLayer ||= [];
  window.gtmEventTracker ||= eventListeners;
};

const gtmEventTracker = {
  initialize,
  ...eventListeners,
};

export default gtmEventTracker;
